import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { cloneDeep } from 'lodash'
import InputPortal from '@/components/edit/InputPortal/index.vue'
import Loader from '@/components/Loader/index.vue'

import { faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import Control from '@/helpers/control'

library.add(faTrashAlt, faCheck)

interface Item {
	label: string
}

@Component({
	components: {
		InputPortal,
		Loader,
	},
})
export default class ManageArray extends Vue {
	@Prop() readonly array!: []
	@Prop() readonly clearAccents!: boolean
	@Prop({ default: null }) readonly options!: [any]
	@Prop({ default: 'fulano@empresa.com.br' }) readonly placeholder!: string
	@Prop() readonly!: boolean

	dynamicArray: any[] = []
	key = 0
	deleteKey = 0
	keyObject = 0
	loading = false
	success = false
	first = false

	control = new Control()

	async created() {
		this.start()
	}

	start() {
		if (!Array.isArray(this.array)) {
			console.error('Array prop is not a valid array')
		} else {
			if (this.array.length === 0) {
				this.first = true
			}
			this.dynamicArray = cloneDeep(this.array)
		}
	}

	itemRemove(item, index: number) {
		if (this.dynamicArray) {
			this.dynamicArray.splice(index, 1)
			this.rerender('delete')
			this.onUpdate()
		}
	}

	itemAdd() {
		if (!this.dynamicArray) {
			this.dynamicArray = []
		}

		if (this.dynamicArray) {
			if (this.dynamicArray.length === 0) {
				this.first = false
			}
			this.dynamicArray.push('')
			this.rerender()
		}
	}

	rerender(type?) {
		if (type === 'delete') this.deleteKey++
		else this.key++
	}

	rerenderOnlyFirst() {
		return this.first
	}

	onInput(newValue, index) {
		if (this.dynamicArray) {
			this.dynamicArray.splice(index, 1, newValue)
			this.keyObject++

			const debouncedChange = this.control.debounce(this.onUpdate, 1000)
			debouncedChange()
		}
	}

	onUpdate() {
		this.setLoading(true)

		if (this.clearAccents) {
			this.dynamicArray = this.dynamicArray.map((item) => {
				return removeAccents(item)
			})
		}

		this.$emit('onUpdate', this.dynamicArray)
	}

	setLoading(value) {
		this.loading = value
		this.rerender()
	}

	setSuccess(value) {
		this.success = value
		this.rerender()
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
